export const SUPPORT_LINK_URL = "/";
export const FAQS_LINK =
  "https://help.hopper.com/en_us/categories/help-with-flights-Hywr1lPz_";
export const INSURANCE_POLICY_LINK =
  "https://studio-la.chubb.com/br-nuviagens-travel/";
const INSURANCE_WHATSAPP_PHONE = "551121859680";
const INSURANCE_WHATSAPP_MESSAGE =
  "Olá! Eu sou cliente Nubank Ultravioleta em viagem comprada pelo NuViagens e gostaria de verificar a lista de hospitais disponíveis para utilização através do Seguro Viagem no meu destino.";
export const INSURANCE_WHATSAPP_LINK = `https://api.whatsapp.com/send?phone=${INSURANCE_WHATSAPP_PHONE}&text=${encodeURIComponent(INSURANCE_WHATSAPP_MESSAGE)}`;
export const INSURANCE_PHONE_NUMBER = "551121859679";
